module.exports = __webpack_public_path__ + "img/money-helper.d85a60dc.png";